import Udesk from 'Udesk';

interface AuthParams {
    email?: string;
    timestamp?: string;
    sign?: string;
}

interface GetFindLatestDataProps extends AuthParams {
    domain?: string;
    callId?: string;
}

export const getFindLatestData = (props: GetFindLatestDataProps) => {
    const { domain, callId, email, timestamp, sign } = props;

    return Udesk.ajax.get(
        `${window.location.origin}/api/v1/middleware/thirdparty/${domain}/findLatestData/${callId}?email=${email}&timestamp=${timestamp}&sign=${sign}`
    );
};

interface GetInspectionDataProps extends AuthParams {
    domain?: string;
    inspectId?: number;
    taskId?: number;
}

export const getInspectionData = (props: GetInspectionDataProps) => {
    const { domain, inspectId, taskId, email, timestamp, sign } = props;

    return Udesk.ajax.get(
        `${window.location.origin}/api/v1/middleware/thirdparty/mobile/${domain}/inspectionData/${inspectId}?taskId=${taskId}&email=${email}&timestamp=${timestamp}&sign=${sign}`
    );
};
